/**
 * ScrollTo.js
 */

import $ from 'jquery';
import gsap from 'gsap'


export default class ScrollTo {

    constructor() {

        this.window = window;
        this.jumpLinks = $('.jump-link');
        this.jumpLinks.on('click', this.scrollToSection);

    }

    scrollToSection(event) {
        if (this.hash !== "") {
            event.preventDefault();

            var hash = this.hash;
            var headerHeight = $('.header-navigation').height();

            gsap.to(window, {
                duration: 1,
                scrollTo: {
                    y: hash,
                    offsetY: headerHeight,
                },
            });

        }
    }

}
